import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImageTextStory } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import StoryMidPromotion from "../../storyMidContent";
import { isPremium } from "../../../../../data/story";
import { humanizeDate } from "../../../../utils/time-format";
import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";
import GooglePreference from "../../../../atoms/google-preference";

function Explainer(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const referenceUrl = get(props, ["story", "metadata", "reference-url"], null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const story = get(props, ["story"], () => null);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const cardLength = cards.length;

  const adShow = isPremium(story) ? !readMore : true;
  const expandComments = get(props, ["expandComments"], () => null);
  const [commentsCount, setCommentsCount] = useState(null);
  const storyId = get(props, ["story", "id"], "");
  const [showShare, setShowShare] = useState(false);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  const heroimageWithShare = (
    <React.Fragment>
      <HeroImageTextStory story={props.story} subSection={section} config={props.config} />
    </React.Fragment>
  );

  return (
    <div className="page-content">
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            <Breadcrumb subSection={section} config={props.config} />
            {renderHeaderCard("", true, false)}
            <p className={`subheadline-main ${styles["subheadline"]}`}>{storyHeadline}</p>
            <div className={styles["published-time-wrap"]}>
              {story["first-published-at"] && (
                <span className={styles["published"]}>
                  Published:
                  <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                    {humanizeDate(story["first-published-at"], "relative")}
                  </time>
                </span>
              )}
              {story["last-published-at"] && (
                <span className={styles["updated"]}>
                  Updated:
                  <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                    {humanizeDate(story["last-published-at"], "relative")}
                  </time>
                </span>
              )}
            </div>
            <div className={styles["hero-image-wrapper"]}>{heroimageWithShare}</div>

            <div className={styles["audio-share-wrapper"]}>
              <div className={styles["audio-comments-share"]}>
                <div>
                  <GooglePreference story={story} />
                </div>

                <div className={styles["box-div"]} onClick={scrollToComments}>
                  <Icon type="comment" />
                  <span className={styles["channel-txt"]}>
                    {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                  </span>
                  <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                </div>
                <div
                  className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                  onClick={handleShareClick}
                >
                  <Icon type="socialshare" />
                  <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                </div>
              </div>

              <div className={styles["social-share-wrapper"]}>
                {showShare && !readMore && renderSocialMedia("", false)}
              </div>
            </div>

            {cards &&
              cards.map((card, index) => {
                return (
                  <React.Fragment key={card.id}>
                    {index === 1 && <div>{index === 1 ? <StoryMidPromotion story={props.story} /> : null}</div>}
                    <StoryCard
                      card={card}
                      story={props.story}
                      showCard={readMore}
                      cardLength={cardLength}
                      renderRelatedArticle={renderRelatedArticle}
                      config={props.config}
                    />
                  </React.Fragment>
                );
              })}

            <div id="we-story-end" />
            {referenceUrl && (
              <div className={styles["external-link-wrapper"]}>
                <Link href={referenceUrl} className={styles["external-link"]} externalLink={referenceUrl}>
                  View Story
                </Link>
              </div>
            )}
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>
          </article>
          {renderFooter(readMore)}
        </div>

        {renderSidebar(adShow)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
Explainer.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func
};

export { Explainer };
